import React from "react";
import styled from "styled-components";
import Button from "./Button";

const FloatButton = (props) => {
  return (
    <Container bottomMenu={props.bottomMenu} padding={props.padding}>
      <Button
        severity={props.severity}
        disable={props.disable}
        clickEvent={props.event}>
        {props.text}
      </Button>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  z-index: 100;
  width: calc(100% - 40px);
  /* padding: 44px 0px 24px 0px; */
  padding: ${props =>
    props.bottomMenu
      ? "44px 20px 24px 20px"
      : props.padding
      ? "44px 20px 24px 20px"
      : "44px 0px 24px 0px"};
  flex-direction: column;
  align-items: center;
  gap: 10px;

  position: absolute;
  bottom: ${props => (props.bottomMenu ? "95px" : "0px")};

  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.94) 36.5%,
    #fff 100%
  );
`;
export default FloatButton;
